import z from "zod";
import { AuditMetaSchema } from "./auditMetaTypes";
import { GrantsSchema, InvitationSchema, RoleSchema } from "./grantsTypes";
import { ProjectIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";

export const ProjectSchema = z
  .object({
    id: ProjectIdSchema,
    name: z.string(),
    description: z.string(),
    default: z.boolean().optional(),
    grants: GrantsSchema,
    role: RoleSchema,
    createdByName: z.string().optional(),
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);
export type Project = z.infer<typeof ProjectSchema>;

export const ProjectWithInvitesSchema = ProjectSchema.extend({
  invites: z.array(InvitationSchema).nullable().optional(),
});
export type ProjectWithInvites = z.infer<typeof ProjectWithInvitesSchema>;
